module.exports = __webpack_public_path__ + "videos/a08aae000ad16b28210764d7fd578e0b.mp4";